import { render, staticRenderFns } from "./scheme.vue?vue&type=template&id=37e82d3e&scoped=true"
import script from "./scheme.vue?vue&type=script&lang=js"
export * from "./scheme.vue?vue&type=script&lang=js"
import style0 from "./scheme.vue?vue&type=style&index=0&id=37e82d3e&prod&lang=scss&scoped=true"
import style1 from "./scheme.vue?vue&type=style&index=1&id=37e82d3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e82d3e",
  null
  
)

export default component.exports